import React from 'react';
import clockIcon from "../../../assets/icons/clockIcon.svg";

function ClockIcon() {
    return (  
        <img src={clockIcon} alt="clockicon.svg" className="clock-icon"/>
    );
}

export default ClockIcon;